import { useEffect, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';
import { HosApiDashboardDevices } from '../../types/apiTypes';
import { DashboardDevice } from '../../types/commonTypes';
import { useFetch } from '../useFetch';

export const useDevices = () => {
  const [devices, setDevices] = useState<DashboardDevice[]>([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();
  const isRes = operator?.type === 'Residential' ?? false;

  useEffect(() => {
    if (response)
      setDevices(response.map((r: HosApiDashboardDevices) => mapDevice(r)));
  }, [response]);

  const getDevices = () => {
    makeRequest(
      `${BASE_URL_MAP[operator.type]}/${operator?.id}${
        isRes ? '' : 'Dashboard'
      }//DeviceCounts`,
      'get'
    );
  };

  return { devices, getDevices, loading };
};

const mapDevice = (device: HosApiDashboardDevices): DashboardDevice => ({
  id: device.Model,
  value: device.InAccounts,
  model: device.Model,
  inAccounts: device.InAccounts,
  inInventory: device.InInventory,
  disabled: device.Disabled,
  total: device.Total,
});
